module.exports = __webpack_public_path__ + "static/media/platform.de71a594.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/categories/platform.png
// module id = 479
// module chunks = 0